<!--TeBanner:教师首页轮播图 2021/03/17 11:07:56 YuAng-->

<template>
  <div v-show="hasBanner" class="its-te-banner" :class="'count' + banners.length">
    <el-carousel height="120px">
      <el-carousel-item v-for="(item, index) in banners" :key="'banner-' + index">
        <a :href="item.jumpAddress" target="_blank">
          <img :src="item.fileUrl" object-fit="scale-down" />
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { teacherHomeApi } from '@/utils/api'
export default {
  name: 'TeBanner',
  props: {
     hasBanner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      banners: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData: function () {
      teacherHomeApi.getBanners().then((resp) => {
        this.banners = resp.body
        this.$emit('update:hasBanner',  this.banners && this.banners.length > 0)
      })
    }
  }
}
</script>

<style scoped>
.its-te-banner {
  min-height: 120px;
  background: white;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  margin-bottom: 20px;
}

.its-te-banner a,
.its-te-banner img {
  width: 100%;
  height: 100%;
  display: inline-block;
  border-radius: 4px;
}

.its-te-banner >>> .el-carousel__button {
  width: 8px;
  height: 8px;
  border-radius: 4px;
}

.its-te-banner >>> .el-carousel__indicators--horizontal {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  bottom: 10px;
}

.its-te-banner >>> .el-carousel__indicator--horizontal {
  padding: 0 4px 2px 4px;
  vertical-align: middle;
}

.its-te-banner.count1 >>> .el-carousel__indicators--horizontal,
.its-te-banner.count1 >>> .el-carousel__arrow {
  display: none !important;
}
</style>